import Menu from 'assets/images/home/Menu.svg'
import { useDispatch } from 'react-redux'
import { toggleSideBar } from 'store/redux/sidebar'
interface IHeaderProps {
    title: string
}
export default function Header({ title }: IHeaderProps) {
    const dispatch = useDispatch()
    return (
        <>
            <div className="bg-header-bg w-full px-4 h-14 flex items-center justify-between sticky top-0 z-20 shadow-header">
                <button
                    type="button"
                    aria-label="منو"
                    onClick={() => dispatch(toggleSideBar({ isOpen: true }))}
                    className="-m-2.5 p-2.5 active:scale-90"
                >
                    <img src={Menu} className="w-6 h-6" alt="" />
                </button>
                <p className="text-green-1 text-2xl font-bold tracking-tight">
                    {title}
                </p>
                <span className="w-6" />
            </div>
        </>
    )
}
